import { Building2 } from 'lucide-react';
import { motion } from 'framer-motion';

interface SuspensionNoticeProps {
  onBack: () => void;
}

export function SuspensionNotice({ onBack }: SuspensionNoticeProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center"
    >
      <div className="w-16 h-16 bg-gradient-to-br from-[#5D1828] to-[#7A2235] rounded-2xl flex items-center justify-center mx-auto mb-4">
        <Building2 size={32} className="text-white" />
      </div>

      <p className="text-sm font-semibold text-[#6B7280] mb-1">
        CPC
      </p>
      <h1 className="text-3xl font-bold text-[#111827] mb-4">
        Acceso suspendido
      </h1>

      <p className="text-[#6B7280] mb-3">
        El acceso a la plataforma de CPC se encuentra suspendido por el momento.
      </p>
      <p className="text-[#6B7280] mb-8">
        Para cualquier aclaración, póngase en contacto con el equipo de desarrollo.
      </p>

      <button
        type="button"
        onClick={onBack}
        className="text-sm text-[#5D1828] hover:text-[#7A2235] font-medium transition-colors"
      >
        Volver al inicio de sesión
      </button>
    </motion.div>
  );
}
